import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {readNotificacion, delNotificacion, getNotificaciones} from '../../services';
import {INotificacion, INotificacionFilter, INotificacionRes, INotificacionState} from "../types/INotificacion";
import {setDashBoardState, setIndicadoresMenu} from "./dashBoardReducers";
import {AppState} from "./rootReducer";

const initialState: INotificacionState= {
    status: "idle",
}

export const mostrarNotificaciones = createAsyncThunk(
    'mostrarNotificaciones', async (params:INotificacionFilter | undefined, thunkAPI ) => {

        const {notificaciones} = thunkAPI.getState() as AppState;
        let paramsFilter = params || notificaciones.filtered;

        const response = await getNotificaciones(paramsFilter)

        return {data: response.data as INotificacionRes, params: response.config.params}
    }
)

export const marcarNotLeida = createAsyncThunk(
    'marcarNotLeida', async (ids: number[], thunkAPI) => {
        let response = await readNotificacion(ids.join(","));

        if (response.status === 200 || response.status === 204) {
            thunkAPI.dispatch(setIndicadoresMenu({notificaciones: -1}))
        }

        return ids;

    }
);
export const eliminarNotificacion = createAsyncThunk(
    'notificacion/eliminar', async (ids: number[], thunkAPI) => {
        await delNotificacion(ids.join(","));
        thunkAPI.dispatch(setDashBoardState({
            notificaciones: -ids.length,
            solicitudes: 0//data.tipo === TIPO_NOTIFICACION.SOLICITUD? 1: 0
        }))
        return ids;
    }
);


const slice = createSlice({
    name: 'mostrarNotificaciones',
    initialState,
    reducers: {
        addNewNotification(state,action: PayloadAction<INotificacion>,) {
            if(state.list){
                state.list = {
                    ...state.list,
                    totalCount: (state.list?.totalCount ?? 0) + 1,
                    items: [action.payload, ...state.list.items]

                }
            }

           // state.list = [...(state.list ?? []), action.payload];
        },
    },
    extraReducers: builder => {
        //--mostrarNotificaciones
        builder.addCase(mostrarNotificaciones.pending, (state ) => {
            state.status = "loading";
        })
        builder.addCase(mostrarNotificaciones.fulfilled, (state,action ) => {
            state.status = "idle";
            state.list = action.payload.data;
        })
        builder.addCase(mostrarNotificaciones.rejected, (state ) => {
            state.status = "idle";
        })
        //--marcarNotLeida
        builder.addCase(marcarNotLeida.pending, (state ) => {
            state.status = "loading";
        })
        builder.addCase(marcarNotLeida.fulfilled, (state,action ) => {
            state.status = "idle";
            const ids = action.payload;

            if (!state.list) return;

            let markedCount = 0;

            state.list.items = state.list.items.map(item => {
                if (item.id && ids.includes(item.id) && !item.leida) {
                    markedCount++;
                    return { ...item, leida: true };
                }
                return item;
            });

            state.list.totalCount = Math.max(
                0,
                state.list.totalCount - markedCount
            );

        })
        builder.addCase(marcarNotLeida.rejected, (state ) => {
            state.status = "idle";
        })
        //--eliminarNotificacion
        builder.addCase(eliminarNotificacion.pending, (state ) => {
            state.status = "loading";
        })
        builder.addCase(eliminarNotificacion.fulfilled, (state,action ) => {
            state.status = "idle";

            const ids = action.payload;
            if(state.list){
                state.list = {
                    ...state.list,
                    items: state.list?.items.filter(e => !ids.includes(e.id!)),
                    totalCount: state.list.totalCount - ids.length

                }
            }
        })
        builder.addCase(eliminarNotificacion.rejected, (state ) => {
            state.status = "idle";
        })
    }

});


export const {addNewNotification} = slice.actions;

export default slice.reducer;
